/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbPersonnelTutelleGridDto } from './FcbPersonnelTutelleGridDto';
import {
    FcbPersonnelTutelleGridDtoFromJSON,
    FcbPersonnelTutelleGridDtoFromJSONTyped,
    FcbPersonnelTutelleGridDtoToJSON,
} from './FcbPersonnelTutelleGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbPersonnelTutelleGridDtoPaginatedResults
 */
export interface FcbPersonnelTutelleGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbPersonnelTutelleGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbPersonnelTutelleGridDto>}
     * @memberof FcbPersonnelTutelleGridDtoPaginatedResults
     */
    results?: Array<FcbPersonnelTutelleGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbPersonnelTutelleGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbPersonnelTutelleGridDtoPaginatedResults interface.
 */
export function instanceOfFcbPersonnelTutelleGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbPersonnelTutelleGridDtoPaginatedResultsFromJSON(json: any): FcbPersonnelTutelleGridDtoPaginatedResults {
    return FcbPersonnelTutelleGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbPersonnelTutelleGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbPersonnelTutelleGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbPersonnelTutelleGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbPersonnelTutelleGridDtoPaginatedResultsToJSON(value?: FcbPersonnelTutelleGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbPersonnelTutelleGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

